(ns kyber.styles.core
  (:require ["jss" :as jss-import]
            ["jss-preset-default" :as preset-default-import]

            [kyber.styles.animations :refer [animation-styles]]
            [kyber.styles.base :refer [base-styles]]
            [kyber.styles.border-radius :refer [border-radius]]
            [kyber.styles.colors :refer [colors]]
            [kyber.styles.form :refer [base-form-styles]]
            [kyber.styles.markup-editor :refer [markup-editor]]
            [kyber.styles.media-queries :refer [queries]]
            [kyber.styles.notifier :refer [notifier-styles]]
            [kyber.styles.overlays :refer [overlay]]
            [kyber.styles.rich-text :refer [rich-text-styles]]
            [kyber.styles.shadows :refer [shadows]]
            [kyber.styles.spacing :refer [spacing]]
            [kyber.styles.typography :refer [line-height
                                             size
                                             weight
                                             font-families]]
            [applied-science.js-interop :as j]))

(def jss (j/get jss-import :default))
(def preset (j/get preset-default-import :default))
(j/call jss :setup (preset))

(def styles
  {:colors colors
   :font-family font-families
   :font-height line-height
   :font-size size
   :font-weight weight
   :overlay (overlay colors)
   :queries queries
   :shadows shadows
   :spacing spacing
   :radius border-radius})

(defn gs
  "Get Style"
  [lens]
  (let [style (get-in styles
                      lens
                      (js/Error (str "No style found for " lens)))]

    (if (= (type style) js/Error)
      (js/console.error style)
      style)))

(defn classes
  [styles]
  (js->clj
   (j/get
    (j/call
     (j/call jss :createStyleSheet (clj->js styles))
     :attach)
    :classes)
   :keywordize-keys true))

(classes
 {"@global"
  (merge (base-styles gs)
         (animation-styles gs)
         (base-form-styles gs)
         (notifier-styles gs)
         (markup-editor gs)
         (rich-text-styles gs))})

(def styles->classes classes)
(def styles->class
  #(-> {:root %} classes :root))
